export const DISHES =
    [
        {
            id: 0,
            name: 'Roadster',
            image: '/assets/images/m1.jpg',
            category: 'mains',
            label: 'Hot',
            price: '4.99',
            featured: true,
            description: 'Charcoal grey, maroon and black striped T-shirt, has a polo collar, long sleeves.Soft, well-structured, and durable, you will definitely love being the proud owner of this Roadster T-shirt. When you are grabbing a quick meal with your friends, this charcoal piece looks great with slimmer pants and chukka boot.'
        },
        {
            id: 1,
            name: 'Black Printed Kurti',
            image: '/assets/images/w1.jpg',
            category: 'appetizer',
            label: '',
            price: '1.99',
            featured: false,
            description: 'Black knitted kurti, has a notched round neck with binding along the neckline, three-quarter length sleeves with contrast printed detail on the hems, contrast print on the front and back yoke, vented hem with a contrast printed detail along the hem.'
        },
        {
            id: 2,
            name: 'Printed Polo Collar T-shirt',
            image: '/assets/images/k1.jpg',
            category: 'appetizer',
            label: 'New',
            price: '1.99',
            featured: false,
            description: 'White printed T-shirt, has a polo collar, and short sleeves.'
        },
        {
            id: 3,
            name: 'Austin wood',
            image: '/assets/images/m2.jpg',
            category: 'dessert',
            label: '',
            price: '2.99',
            featured: false,
            description: 'Navy Blue and Grey striped T-shirt, has a polo collar, and short sleeves.Soft, well-structured, and durable, you will definitely love being the proud owner of this Roadster T-shirt. Wear this navy blue piece many ways, with dark wash jeans, cuffed chinos and more.'
        },
        {
            id: 4,
            name: 'Navy Blue Kurta',
            image: '/assets/images/w2.jpg',
            category: 'dessert',
            label: '',
            price: '3.99',
            featured: false,
            description: 'Navy blue and off-white yoke design kurta with palazzos Navy blue straight yoke design calf length kurta with mirror work, has a round neck, three-quarter sleeves, straight hem, side slits Off-white printed palazzos, has elasticated waistband, drawstring closure'
        },
        {
            id: 5,
            name: 'Textured Long T-Shirt',
            image: '/assets/images/k2.jpg',
            category: 'dessert',
            label: '',
            price: '1.99',
            featured: false,
            description: 'Soft textured knit. Long sleeves with banded cuffs. Ribbing at crewneck. Curved hem.'
        },
        {
            id: 6,
            name: 'Polo Collar T-shirt',
            image: '/assets/images/m3.jpg',
            category: 'dessert',
            label: '',
            price: '2.99',
            featured: false,
            description: 'Black solid T-shirt, has a polo collar, short sleeves, 1 pocket.Why choose between making a style statement and staying comfortable when you have the HRX Mens Outdoor T-shirt. The lightweight t-shirt folds into a small package to take minimal space in your overnighter and opens up to a t-shirt you will never want to take off.'
        },
        {
            id: 7,
            name: 'Green Block Printed Top',
            image: '/assets/images/w3.jpg',
            category: 'dessert',
            label: '',
            price: '4.99',
            featured: false,
            description: 'White, green and purple printed woven high-low top, has a round neck, three-quarter sleeves, and button closure.'
        },
        {
            id: 8,
            name: 'Printed Drop-Waist Dress',
            image: '/assets/images/k3.jpg',
            category: 'dessert',
            label: '',
            price: '2.99',
            featured: false,
            description: 'Blue printed woven drop-waist dress, has a round neck, short sleeves, button closure, and flared hem.'
        },
        {
            id: 9,
            name: 'Kook N Keech Disney',
            image: '/assets/images/m4.jpg',
            category: 'dessert',
            label: '',
            price: '3.99',
            featured: false,
            description: 'Black and white printed T-shirt, has a round neck, short sleeves.Pull over this snug tee to keep your style looking fresh. This grey melange shirt is the perfect note to strike with a pair of skinny jeans when you are looking for a simple night out at the bars.'
        },
        {
            id: 10,
            name: 'Off-White Printed Tunic',
            image: '/assets/images/w4.jpg',
            category: 'dessert',
            label: '',
            price: '5.99',
            featured: false,
            description: 'Navy blue and off-white printed Tunic with thread-work and gathered detail, has a mandarin collar, three-quarter sleeves, and button closure. Being a Indigo dye, colour will bleed during initial washes. Wash seperately or with darker colours.'
        },
        {
            id: 11,
            name: 'Floral Pattern Dress',
            image: '/assets/images/k4.jpg',
            category: 'dessert',
            label: '',
            price: '3.99',
            featured: false,
            description: 'Smooth weave, fully lined Cap sleeve Gathered in the crew neck, with a zipper on the back Tie belt and gather at the waist Floral print full pattern'
        }
    ];